var path = '/modules/core/components/al-loader/component.tpl.html';
var html = "<div class=\"al-loader al-loader-size-{{vm.size}}\">\n    <lottie-player\n            src=\"/deposits/lottie-animations/loading.json\"\n            background=\"transparent\"\n            speed=\"1\"\n            loop\n            autoplay></lottie-player>\n    <img src=\"/deposits/lottie-animations/loading.gif\"\n         alt=\"Loading animation\"\n         class=\"lottie-img img-responsive p-10\">\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/core/components/al-loader/component.tpl.html
// module id = 2087
// module chunks = 1